import { createFileRoute } from '@tanstack/react-router';

import { ClientsArchivePage } from '@/features/clients/components/clients-archive/clients-archive-page';
import { clientsArchiveSearchSchema } from '@/features/clients/hooks/use-archive-table-state';

// /clients/archivo — vista de clientes archivados (soft-deleted).
// Subruta con schema PROPIO (no hereda el del listado principal,
// porque los campos del listado operativo no aplican acá).
export const Route = createFileRoute('/_app/clients/archivo')({
  validateSearch: (search) => clientsArchiveSearchSchema.parse(search),
  component: ClientsArchivePage,
});
